import { ADD_INVOICE_DETAIL_DEBIT_NOTE_REGISTER, UPDATE_INVOICE_DETAIL_DEBIT_NOTE_REGISTER, SET_ITBIS_TAX_DEBIT_NOTE_REGISTER, DELETE_DEBIT_NOTE_DETAIL_INVOICE_REGISTER
   , DISABLED_TABLE_EDIT_DEBIT_NOTES,RESER_DEBIT_NOTE_REGISTER,SET_BILL_DATA_DEBIT_NOTES,SET_MAX_VALUE_DATA_DEBIT_NOTES, SET_DAY_DIFF_DEBIT_NOTES } from '../../../../constants/ActionTypes'

   import { ID } from '../../../../constants/Config'
   import { currencyFormat, zeroPad } from '../../../../util/DaFrameword';
   const InitialState = {
       TableData: [],
       UltimateItbis: null,
       percentItbis: null,
       IdCurrentRow: ID(),
       DisabledTableUpdate: true,
       MaxValue: 0,
       DayDiff: 0
   }
   
   function DebitNotes(state = InitialState, action) {
       switch (action.type) {
           case ADD_INVOICE_DETAIL_DEBIT_NOTE_REGISTER:
               const NewRow = action.payload;
               //console.log("Agregar", NewRow)
               return {
                   ...state,
                   TableData: [...state.TableData, NewRow],
                   IdCurrentRow: ID()
               }
           case UPDATE_INVOICE_DETAIL_DEBIT_NOTE_REGISTER:
               const UpdateRow = action.payload;
               return {
                   ...state,
                   TableData: state.TableData.map(x => x.id === UpdateRow.id ? { ...UpdateRow, Update: true } : x),
               }
           case DELETE_DEBIT_NOTE_DETAIL_INVOICE_REGISTER:
               const { productId } = action.payload;
               return {
                   ...state,
                   TableData: state.TableData.filter(x => x.productId !== productId)
               }
           case SET_ITBIS_TAX_DEBIT_NOTE_REGISTER:
               return {
                   ...state,
                   UltimateItbis: action.payload.percentItbis * 0.01,
                   percentItbis: action.payload.percentItbis * 0.01
               }
   
           case RESER_DEBIT_NOTE_REGISTER:
               return {
                   ...state,
                   TableData: [],
                   IdCurrentRow: ID()
               }
           case SET_BILL_DATA_DEBIT_NOTES:
               var list = action.payload.details;
               return {
                   ...state,
                   Update: false,
                   TableData: list.map(x => ({
                       DBId: x.id,
                       id: x.id,
                       cost: "0",
                       discount: "0",
                       price: "0",
                       quantity: x.quantity,
                       itbissn: false,
                       value: "0",
                       itbisvalue: "0",
                       total: "0",
                       code: zeroPad(x.code, 8),
                       description: x.description,
                       productId: x.productId,
                       initialItbisValue: "0",
                       Update: false
                   })),
   
               }
   
           case SET_MAX_VALUE_DATA_DEBIT_NOTES:
               return {
                   ...state,
                   MaxValue: action.payload
               }
           case DISABLED_TABLE_EDIT_DEBIT_NOTES:
               return {
                   ...state,
                   DisabledTableUpdate: action.payload
               }
   
           case SET_DAY_DIFF_DEBIT_NOTES:
               var ListData = [];
               if (action.payload > 30) {
                   ListData = state.TableData.map((x) => ({
                       ...x,
                       itbisvalue: "0.00",
                       total: currencyFormat(Number(x.value.replaceAll(',', '')) - Number((x.discount.toString() ?? "0").replaceAll(',', '')))
                   }))
               } else {
                   ListData = state.TableData.map((x) => ({
                       ...x,
                       itbisvalue: x.Update == false ? currencyFormat(x.initialItbisValue) : currencyFormat((Number(x.value.replaceAll(',', '')) - Number((x.discount.toString() ?? "0").replaceAll(',', ''))) * ( x.hasItbis == true ? state.UltimateItbis : 0)),
                       total: currencyFormat(Number(x.value.replaceAll(',', ''))
                                               + (x.Update == false ? (x.initialItbisValue) : ((Number(x.value.replaceAll(',', '')) - Number((x.discount.toString() ?? "0").replaceAll(',', ''))) * ( x.hasItbis == true ? state.UltimateItbis : 0)))
                                               - Number((x.discount.toString() ?? "0").replaceAll(',', '')))
                   }))
               }
   
               return {
                   ...state,
                   TableData: ListData,
                   DayDiff: action.payload,
                   percentItbis: action.payload > 30 ? 0 : state.UltimateItbis
   
               }
           default:
               return state;
       }
   
   }
   
   
   
   export default DebitNotes;